import { Box, Card, Typography, Button, Stack } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

/**
 * MapActionMenu - Action menu displayed on map for bulk operations
 * Positioned on top-left of map, shows selection count and context-specific actions
 *
 * Props:
 * - mode: "location" | "call" - Determines which actions to show
 * - selectedCount: number - Count of selected items
 * - onChangeTerritory: () => void - Location mode: change territory for selected locations
 * - onChangeRep: () => void - Call mode: change rep for selected calls
 * - onReschedule: () => void - Call mode: reschedule selected calls
 * - onClearSelection: () => void - Required: clear all selections
 */
const MapActionMenu = ({
  mode = "location",
  selectedCount = 0,
  onChangeTerritory,
  onChangeRep,
  onReschedule,
  onClearSelection,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <Card
      sx={{
        position: "absolute",
        left: 16,
        top: 16,
        zIndex: 1000,
        p: 2,
        minWidth: 220,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <Stack spacing={1.5}>
        {/* Selection count header */}
        <Box>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: "bold", mb: 0.5 }}
          >
            Selected: {selectedCount}
          </Typography>
        </Box>

        {/* Location mode actions */}
        {mode === "location" && (
          <>
            <Button
              size="small"
              variant="outlined"
              fullWidth
              onClick={onChangeTerritory}
              disabled={!onChangeTerritory}
            >
              Change Territory
            </Button>
          </>
        )}

        {/* Call mode actions */}
        {mode === "call" && (
          <>
            <Button
              size="small"
              variant="outlined"
              fullWidth
              onClick={onChangeRep}
              disabled={!onChangeRep}
            >
              Change Rep
            </Button>
            <Button
              size="small"
              variant="outlined"
              fullWidth
              onClick={onReschedule}
              disabled={!onReschedule}
            >
              Reschedule
            </Button>
          </>
        )}

        {/* Clear selection button */}
        <Button
          size="small"
          variant="text"
          fullWidth
          startIcon={<ClearIcon />}
          onClick={onClearSelection}
          sx={{ color: "text.secondary" }}
        >
          Clear
        </Button>
      </Stack>
    </Card>
  );
};

export default MapActionMenu;
